import React from "react";
import styles from "./HeaderMobile.module.scss";
import { ReactComponent as CloseIcon } from "../../../../assets/svg/close.svg";

const HeaderMobile = (props) => (
  <div className={styles.HeaderDesktop}>
    <div>
      {props.title && <div className={styles.title}>{props.title}</div>}

      {props.subtitle && (
        <div className={styles.subtitle}>{props.subtitle}</div>
      )}
    </div>
    <div className={styles.hright}>
      {props.step && (
        <span className={styles.step}>
          {" "}
          {Math.floor(props.step)}/{props.maxStep ? props.maxStep : 3}
        </span>
      )}
      <CloseIcon
        className={styles.close}
        onClick={() => {
          props.setBoxContent(false);

          if (props.onClose) {
            props.onClose();
          }
        }}
      />
    </div>
  </div>
);

HeaderMobile.defaultProps = {};

export default HeaderMobile;
